export default {
    boardIdAndToken: "581657007-136aa9fd1bbac5c25f0cf5bac147d93d",
    tooltipText: "Try it out here",
    liveBoard: false
};
